import Select from 'react-select';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { listCategories } from '../../actions/NavigationActions';

class CategorySelect extends Component {
    componentDidMount() {
        this.props.listCategories();
    }

    render() {
        const { handleCategoryChange, isRequired } = this.props;
        let { selectedCategory } = this.props;

        const { categories } = this.props.categories;
        const refinedCategories = [];

        for (let i = 0; i < categories.length; i++) {
            refinedCategories.push({
                value: categories[i].id,
                label: categories[i].name,
            });
            const subcategories = categories[i].children;

            for (let j = 0; j < subcategories.length; j++) {
                refinedCategories.push({
                    value: subcategories[j].id,
                    label: `-- ${subcategories[j].name}`,
                });
            }
        }

        if (this.props.defaultCategoryId.length > 0) {
            const { defaultCategoryId } = this.props;
            selectedCategory = refinedCategories.find(category => category.value === parseInt(defaultCategoryId, 10));
        }

        return (
            <div id="forms_container">
                <fieldset className="search">
                    <div className="form-group input-field">
                        <label className="category-label">
                            Category
                            {isRequired ?
                                <span style={{
                                    color: '#FF0000',
                                    paddingLeft: '5px',
                                }}
                                >*
                                </span> :
                                ''
                            }
                        </label>
                        <div className="input-select">
                            <Select
                                className="category-selector"
                                options={refinedCategories}
                                placeholder="Please select category"
                                onChange={handleCategoryChange}
                                value={selectedCategory}
                            />
                        </div>
                    </div>
                </fieldset>
            </div>
        );
    }
}

CategorySelect.defaultProps = {
    selectedCategory: null,
    isRequired: null,
    categories: null,
    defaultCategoryId: '',
};

CategorySelect.propTypes = {
    selectedCategory: PropTypes.any,
    isRequired: PropTypes.any,
    categories: PropTypes.any,
    defaultCategoryId: PropTypes.string,
    handleCategoryChange: PropTypes.func.isRequired,
    listCategories: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listCategoriesReducer }) => ({
    categories: listCategoriesReducer,
});

export default connect(mapStateToProps, { listCategories })(CategorySelect);
